// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Icons } from './Icons';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <a href="/" className="logo">
            <Icons.Shield />
            <span>Atri Bot</span>
          </a>
          <nav className="nav">
            <a href="/#features">Возможности</a>
            <a href="/#commands">Команды</a>
            <a href="/#settings">Настройки</a>
            <a href="/#guide">Инструкция</a>
            <a href="/#faq">FAQ</a>
            <a href="https://atri-bot.online" className="nav-cta">Онлайн-панель</a>
            <a href="/#contact" className="nav-cta">Добавить бота</a>
          </nav>
          <button className="mobile-menu-btn">
            <Icons.Menu />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;